import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-dark border-top text-light shadow py-2" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "pl-2 list-unstyled" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-500",
    href: "http://abplussoftware.fr"
  }, "AB+ SOFTWARE")
], -1)
const _hoisted_7 = {
  class: "text-500",
  href: "/"
}
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { class: "pl-2 list-unstyled" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.linkedin.com/company/ab-plus-software/",
      target: "_blank",
      class: "text-500"
    }, "Linkedin")
  ])
], -1)
const _hoisted_11 = { class: "ml-auto col-5 d-flex text-left" }
const _hoisted_12 = { class: "text-500 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_b_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('list.usefull.title')), 1),
            _createElementVNode("ul", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('list.usefull.home')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.$t('list.socialNetworks.title')), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              class: "mt-1 mr-3",
              icon: [_ctx.$store.state.family, 'info-circle']
            }, null, 8, ["icon"]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('cookieUsage')), 1)
          ])
        ])
      ], undefined, true),
      _: 1
    })
  ]))
}